import { useMemo } from 'react';
import type { ModuleKey } from '../store/useSessionStore';
import { useSessionStore } from '../store/useSessionStore';
import { canModuleAction, permissionAllowsAction } from '../permissions/canModuleAction';

export { canModuleAction, permissionAllowsAction };

/** Imperative helper over current session store (same source as useBranchPermission). */
export function can(module: ModuleKey, action: string, branchId?: string): boolean {
  const state = useSessionStore.getState();
  return canModuleAction(state.branches, branchId ?? state.currentBranchId, module, action);
}

export function useModulePermission(module: ModuleKey, action: string): boolean {
  const currentBranchId = useSessionStore((state) => state.currentBranchId);
  const branches = useSessionStore((state) => state.branches);

  return useMemo(
    () => canModuleAction(branches, currentBranchId, module, action),
    [branches, currentBranchId, module, action]
  );
}
